<template>
  <vjs-modal v-if="redirect" v-bind="$options.propsData"
             name="edit_feed_redirect_modal"
             title="Edit Feed Redirect"
             icon="la la-edit"
             @before-open="init">
    <template #body-content>
      <form>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label for="edit_customer_slug">
                    <strong>Customer Slug <em>*</em></strong>
                  </label>
                  <input id="edit_customer_slug"
                         v-model="redirect.customer_slug"
                         v-validate="'required'"
                         data-vv-scope="edit-redirect-form"
                         name="Customer Slug"
                         type="text"
                         class="form-control"
                         placeholder="customer_slug">
                  <p v-show="errors.has('Customer Slug', 'edit-redirect-form')" class="help text-ss-danger">
                    {{ errors.first('Customer Slug', 'edit-redirect-form') }}
                  </p>
                </div>
              </div>
              <div class="col-12 col-md-6">
                <div class="form-group">
                  <label>
                    <strong>Lookup Customer Slug</strong>
                  </label>
                  <multiselect v-if="customers.length"
                               v-model="selected_customer"
                               :options="customers"
                               label="name"
                               placeholder="Select a customer..."
                               @input="customerSelected()" />
                </div>
              </div>
            </div>

            <div class="form-group mb-4">
              <label for="edit_feed_file_name">
                <strong>Feed File Name <em>*</em></strong>
              </label>
              <input id="edit_feed_file_name"
                     v-model="redirect.feed_file_name"
                     v-validate="'required'"
                     data-vv-scope="edit-redirect-form"
                     name="Feed File Name"
                     type="text"
                     class="form-control"
                     placeholder="my-feed-file.xml">
              <p v-show="errors.has('Feed File Name', 'edit-redirect-form')" class="help text-ss-danger">
                {{ errors.first('Feed File Name', 'edit-redirect-form') }}
              </p>
            </div>

            <div class="form-group mb-4">
              <label for="edit_redirect_to">
                <strong>Redirect To (URL) <em>*</em></strong>
              </label>
              <input id="edit_redirect_to"
                     v-model="redirect.to_url"
                     v-validate="'required|url'"
                     data-vv-scope="edit-redirect-form"
                     name="Redirect To"
                     type="text"
                     class="form-control"
                     placeholder="https://feeds.sharp-stream.com/content/{customer_slug}/feed-files/{feed-file-name.xml}">
              <p v-show="errors.has('Redirect To', 'edit-redirect-form')" class="help text-ss-danger">
                {{ errors.first('Redirect To', 'edit-redirect-form') }}
              </p>
            </div>

            <div class="form-group mb-4">
              <label for="edit_response_code">
                <strong>Response Code <em>*</em></strong>
              </label>
              <input id="edit_redirect_to"
                     v-model="redirect.response_code"
                     v-validate="'numeric'"
                     data-vv-scope="edit-redirect-form"
                     name="Response Code"
                     type="text"
                     class="form-control"
                     placeholder="301">
              <p v-show="errors.has('Response Code', 'edit-redirect-form')" class="help text-ss-danger">
                {{ errors.first('Response Code', 'edit-redirect-form') }}
              </p>
            </div>

            <div class="form-group mb-4">
              <label for="edit_comment">
                <strong>Comment <em>*</em></strong>
              </label>
              <textarea id="edit_comment"
                        v-model="redirect.comment"
                        name="Comment"
                        type="text"
                        class="form-control"
                        placeholder="Why have you added this redirect ?" />
            </div>
          </div>
        </div>
      </form>
    </template>
    <template #body-controls>
      <b-button :disabled="!can_confirm" variant="ss-standout" @click="submitRedirect">
        Confirm
      </b-button>
      <b-button variant="ss-cancel" @click="() => close(false)">
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>

import FeedRedirectsMixin from "VueMixins/Feeds/FeedRedirectsMixin";

export default {
  name: 'edit_feed_redirect_modal',
  mixins: [FeedRedirectsMixin],
  props: {
    targetRedirect: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    can_confirm() {
      return true;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.redirect = { ...this.targetRedirect };
    },
    submitRedirect() {
      this.$validator.validateAll('edit-redirect-form').then((result) => {
        if (result) {
          axios.patch(`/api/v1/admin/feed-redirects/${this.redirect.id}`, this.redirect).then(() => {
            toastr.success('Redirect Edited.');
            window.EventBus.$emit(`manage-redirects-table-reload`);
            this.close();
          }).catch((error) => {
            this.handleAxiosError(error);
          });
        } else {
          toastr.error("Some fields have not been populated correctly.");
        }
      });
    },
    close() {
      this.$modal.hide('edit_feed_redirect_modal');
    },
  },
};
</script>
